import { render, staticRenderFns } from "./ModalHistoricoSolicitacoes.vue?vue&type=template&id=d4c95dfa&"
import script from "./ModalHistoricoSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoSolicitacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports